/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AttainmentGroupNode, AttainmentNode, AttainmentReferenceNode } from 'common-typescript/types';
import { AttainmentsById } from './AttainmentTreeTypes';

@Component({
    selector: 'sis-attainment-tree-nodes',
    templateUrl: './attainment-tree-nodes.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class AttainmentTreeNodesComponent {
    @Input() attainmentNodes: AttainmentNode[];
    @Input() attainmentsById: AttainmentsById;
    @Input() selectedLocale?: string;

    asAttainmentReferenceNode(attainmentNode: AttainmentNode): AttainmentReferenceNode {
        return attainmentNode as AttainmentReferenceNode;
    }

    asAttainmentGroupNode(attainmentNode: AttainmentNode): AttainmentGroupNode {
        return attainmentNode as AttainmentGroupNode;
    }
}
